import { ToastContainer } from "react-toastify";
import "./App.css";
import EmergencySms from "./modules/emergency-sms";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
      </header>
      <ToastContainer />
      <EmergencySms />
    </div>
  );
}

export default App;
